import React, { useState, useEffect } from "react";
import "./styles.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Tooltip } from "@mui/material";
import { convertNumbers } from "../../../functions/convertNumbers";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import { IconButton } from "@mui/material";
import { addToWatchlist } from "../../../functions/addToWatchlist";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { hasBeenAdded } from "../../../functions/hasBeenAdded";
import { removeFromWatchlist } from "../../../functions/removeFromWatchlist";

function ListComponent({ coin, delay, isWatchlistPage }) {
  const id = coin?.id;
  const [added, setAdded] = useState(() => (id ? hasBeenAdded(id) : false));

  useEffect(() => {
    setAdded(id ? hasBeenAdded(id) : false);
  }, [id]);

  const pct = Number(coin?.price_change_percentage_24h);
  const price = Number(coin?.current_price);
  const mcap = Number(coin?.market_cap);
  const vol = Number(coin?.total_volume);
  const hasPct = Number.isFinite(pct);
  const isDown = hasPct && pct < 0;
  const priceStr = Number.isFinite(price) ? price.toFixed(2) : "—";
  const pctStr = hasPct ? pct.toFixed(2) : "—";
  const mcapDisplay = Number.isFinite(mcap)
    ? mcap.toLocaleString()
    : "—";
  const volDisplay = Number.isFinite(vol) ? vol.toLocaleString() : "—";

  if (!id) {
    return null;
  }

  return (
    <Link to={`/coin/${id}`} className="coin-link">
      <motion.tr
        style={{ display: isWatchlistPage && !added && "none" }}
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: delay }}
        className="list-row"
      >
        <Tooltip title="Coin Logo" placement="bottom">
          <td className="td-image">
            <img className="coin-image" src={coin.image} alt="" />
          </td>
        </Tooltip>
        <Tooltip title="Coin Name" placement="bottom">
          <td>
            <p className="coin-symbol td-coin-sym">{coin.symbol}</p>
            <p className="coin-name td-coin-name">{coin.name}</p>
          </td>
        </Tooltip>
        <Tooltip title="Percentage Change In 24hrs" placement="bottom">
          <td>
            {isDown ? (
              <div className="coin-percentage">
                <p className="red td-percentage">{pctStr}%</p>
                <TrendingDownIcon className="red td-icon" />
              </div>
            ) : (
              <div className="coin-percentage">
                <p className="green td-percentage">{pctStr}%</p>
                <TrendingUpIcon className="green td-icon" />
              </div>
            )}
          </td>
        </Tooltip>
        <Tooltip title="Current Price" placement="bottom">
          <td className="cureent-price td-align-center">
            {isDown ? (
              <p className="current-price-red td-price">${priceStr}</p>
            ) : (
              <p className="current-price-green td-price">${priceStr}</p>
            )}
          </td>
        </Tooltip>
        <Tooltip title="Market Capital" placement="bottom-end">
          <td className="market-details td-align-right mobile-mkt-cap">
            <p>${Number.isFinite(mcap) ? convertNumbers(mcap) : "—"}</p>
          </td>
        </Tooltip>
        <Tooltip title="Market Capital" placement="bottom-end">
          <td className="market-details td-align-right desktop-mkt-cap">
            <p>${mcapDisplay}</p>
          </td>
        </Tooltip>
        <Tooltip title="Total Volume" placement="bottom-end">
          <td className="market-details td-align-right total-volume">
            <p>${volDisplay}</p>
          </td>
        </Tooltip>
        <td style={{ width: "fit-content" }}>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              if (added) {
                removeFromWatchlist(id);
                setAdded(false);
              } else {
                addToWatchlist(id);
                setAdded(true);
              }
            }}
          >
            {added ? (
              <StarRoundedIcon
                className={`watchlist-icon ${
                  isDown && "watchlist-icon-red"
                } `}
              />
            ) : (
              <StarBorderRoundedIcon
                className={`watchlist-icon ${
                  isDown && "watchlist-icon-red"
                } `}
              />
            )}
          </IconButton>
        </td>
      </motion.tr>
    </Link>
  );
}

export default ListComponent;
